import React from 'react';

// Port of .btn / .btn.primary / .btn.secondary from base_component.css.
export function Btn({ variant = 'primary', className = '', children, ...props }) {
  return (
    <button className={`btn ${variant} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}

export default Btn;
